/* eslint no-dupe-keys: off */
import React from 'react';

const style = {
  background: '#000428',
  background: '-webkit-linear-gradient(to bottom, #004e92, #000428)',
  background: 'linear-gradient(to bottom, #004e92, #000428)',
};

const Error404 = () => (
  <section className="u-h-100vh u-flex-center" style={style}>
    <div className="container">
      <div className="row">
        <div className="col-12 text-center">
          <h1 className="text-primary u-fs-60 u-fs-md-150 ">
            404
            <img src="/images/svg/vespa404.svg" alt="" style={{ width: '250px', paddingBottom: '50px' }} />
          </h1>
          <h2 className="mb-4 text-white">Oops! Naletjeli smo na zid!</h2>
          <h3 className="text-white">Link koji tražite ne postoji na našem site-u...</h3>
          <a href="/" className="btn btn-rounded btn-primary mt-5">
            <i className="fa fa-arrow-left text-white" aria-hidden="true" /> POVRATAK NA NASLOVNICU
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default Error404;



// WEBPACK FOOTER //
// ./src/components/Error404.js